interface UserInfo {
  org: string;
  token: string;
}

export const viewPortfolioWatchList = async (userId: string, userInfo: UserInfo) => {
  try {
    // Ensure we have the base URL
    const baseUrl = process.env.REACT_APP_VQ_API_URL || 'https://api.versaquant.com:5000';
    const response = await fetch(`${baseUrl}/run3/pr.viewPortfolioWatchList/[]`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${userInfo.token}`,
        'Accept': 'application/json',
        'X-Organization': userInfo.org
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch watchlist');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching watchlist:', error);
    throw error;
  }
};
